import React, { Component } from "react";
import {
  getFirestore,
  collection,
  getDocs,
  query,
  orderBy,
  limit,
} from "firebase/firestore";

import DashboardSidebar from "../component/dash/DashboardSidebar";
import themeLarge from "../component/ThemeLarge";
import MetricSummary from "../component/vitals/MetricSummary";
import VitalsLineChart from "../component/vitals/VitalsLineChart";
import MetricDistributionChart from "../component/vitals/MetricDistributionChart";
import VitalsLegend from "../component/vitals/VitalsLegend";
import PathVitalsChart from "../component/vitals/PathVitalsChart";
import UserAgentStats from "../component/vitals/UserAgentStats";

class VitalsDashboardView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vitals: [],
      loading: true,
      isSidebarOpen: false,
      groupedMetrics: {}, // for easy visual access
    };
  }

  componentDidMount() {
    this.fetchVitals();
  }

  toggleSidebar = () => {
    this.setState((prev) => ({ isSidebarOpen: !prev.isSidebarOpen }));
  };

  async fetchVitals() {
    try {
      const db = getFirestore();
      const q = query(
        collection(db, "webVitals"),
        orderBy("timestamp", "desc"),
        limit(500)
      );
      const snapshot = await getDocs(q);
      const vitals = snapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .filter((entry) => !entry.path?.startsWith("/dashboard"));

      const groupedMetrics = this.groupByMetric(vitals);

      this.setState({ vitals, groupedMetrics, loading: false });
    } catch (err) {
      console.error("Failed to fetch vitals:", err);
      this.setState({ loading: false });
    }
  }

  groupByMetric = (data) => {
    const grouped = {};

    data.forEach((entry) => {
      const { name } = entry;
      if (!grouped[name]) grouped[name] = [];
      grouped[name].push(entry);
    });

    return grouped;
  };

  render() {
    const { vitals, groupedMetrics, loading } = this.state;

    return (
      <div
        style={{
          display: "flex",
          minHeight: "100vh",
          marginTop: "75px",
        }}
      >
        <DashboardSidebar
          isOpen={this.state.isSidebarOpen}
          onToggle={this.toggleSidebar}
        />

        <div className="container mt-4" style={{ fontFamily: "Kumbh Sans" }}>
          <h4 style={{ color: themeLarge.colors.primary }}>
            📊 Web Vitals Dashboard (Visual)
          </h4>
          <p style={{ fontSize: themeLarge.fontSize.small }}>
            Showing last 500 vitals from real sessions
          </p>

          {loading ? (
            <p>Loading...</p>
          ) : (
            <>
              <VitalsLegend />
              <MetricSummary groupedMetrics={groupedMetrics} />
              <PathVitalsChart groupedMetrics={groupedMetrics} />
              <VitalsLineChart groupedMetrics={groupedMetrics} />
              <MetricDistributionChart groupedMetrics={groupedMetrics} />
              <UserAgentStats vitals={vitals} />
            </>
          )}
        </div>
      </div>
    );
  }
}

export default VitalsDashboardView;
